"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wasticApiContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const admin_1 = require("./admin");
const web_1 = require("./web");
const c = (0, core_1.initContract)();
exports.wasticApiContract = c.router({
    health: {
        method: 'GET',
        path: '/health',
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.default.any()) },
    },
    admin: admin_1.AdminRouter,
    web: web_1.WebRouter,
}, { pathPrefix: '/api/v2' });
__exportStar(require("./admin"), exports);
__exportStar(require("./web"), exports);
